import { render } from "./consume-detail-card.vue?vue&type=template&id=d44c15bc&scoped=true"
import script from "./consume-detail-card.vue?vue&type=script&lang=js"
export * from "./consume-detail-card.vue?vue&type=script&lang=js"

import "./consume-detail-card.vue?vue&type=style&index=0&id=d44c15bc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44c15bc"]])

export default __exports__